module.exports = __webpack_public_path__ + "e840cbf894b4acbf35b76bab2b1115b6.MP3";